import React, { useEffect } from 'react';
import './Tradinghours.css';

const TradingHours = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Trading Hours</h1>
        <p className="subtitle">Trade around the clock across multiple markets.</p>

        <div className="highlight-box">
          <h3>🌍 24/5 Forex Trading</h3>
          <p>The forex market never sleeps. Trade 24 hours a day, 5 days a week.</p>
        </div>

        <div className="section">
          <h2>Forex Trading Sessions</h2>
          <table>
            <thead>
              <tr>
                <th>Session</th>
                <th>Opens (GMT)</th>
                <th>Closes (GMT)</th>
                <th>Major Pairs</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Sydney</td><td>Sunday 22:00</td><td>Monday 07:00</td><td>AUD/USD, NZD/USD</td></tr>
              <tr><td>Tokyo</td><td>Monday 00:00</td><td>Monday 09:00</td><td>USD/JPY, AUD/JPY</td></tr>
              <tr><td>London</td><td>Monday 08:00</td><td>Monday 17:00</td><td>EUR/USD, GBP/USD</td></tr>
              <tr><td>New York</td><td>Monday 13:00</td><td>Monday 22:00</td><td>EUR/USD, USD/CAD</td></tr>
            </tbody>
          </table>
        </div>

        <div className="section">
          <h2>Cryptocurrency Trading</h2>
          <p className="section-text">All cryptocurrencies trade 24/7 including weekends with no breaks.</p>
        </div>
      </div>
    </div>
  );
};

export default TradingHours;